module.exports = __webpack_public_path__ + "img/gd.f1169130.png";